import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Container } from '@mui/material';
import { CalendarToday as CalendarTodayIcon, Task as TaskIcon, AccountTree as AccountTreeIcon, Ballot as BallotIcon, EventAvailable as EventAvailableIcon, EventBusy as EventBusyIcon } from "@mui/icons-material";
import { getData } from "../../services/axiosInstance";
import { API_ENDPOINTS } from "../../services/endpoints";
import Loader from "../../common/spinner";
import PushNotificationManager from "../../services/PushNotificationManager";
import DashboardCard from "../../components/common/DashboardCard";
import { useAttendance } from "../../context/AttendanceContext";

function TeamLeadDashboard() {
    const navigate = useNavigate();
    const { attendanceVersion } = useAttendance();
    const [stats, setStats] = useState({});
    const userDataRaw = localStorage.getItem('userData');
    const userData = userDataRaw ? JSON.parse(userDataRaw) : null;
    const userId = userData?.id;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            if (!userId) return;
            setLoading(true);
            try {
                const url = `${API_ENDPOINTS.getTeamLeadDashboardCounts}?userId=${userId}`;
                const res = await getData(url);
                if (res.status === "SUCCESS") {
                    setStats(res.message?.data || {});
                }
            } catch (e) {
                return null;
            }
            finally {
                setLoading(false); // Stop loading regardless of success/fail
            }
        };
        fetchStats();
    }, [userId, attendanceVersion]);

    const cards = [
        { id: 1, icon: <CalendarTodayIcon />, title: "Total Projects", count: stats.totalProjects, p: "#4158D0", s: "#C850C0", path: "/team-lead/projects" },
        { id: 2, icon: <AccountTreeIcon />, title: "Total Epics", count: stats.totalEpics, p: "#FBAB7E", s: "#F7CE68", path: "/team-lead/epic-management" },
        { id: 3, icon: <BallotIcon />, title: "Total Stories", count: stats.totalUserStories, p: "#21D4FD", s: "#B721FF", path: "/team-lead/stories-management" },
        { id: 4, icon: <TaskIcon />, title: "Active Tasks", count: stats.totalTasks, p: "#08AEEA", s: "#2AF598", path: "/team-lead/task-management" },
        {
            id: 5,
            icon: <EventAvailableIcon />,
            title: "Monthly Attendance",
            count: stats.monthlyAttendancePercentage
                ? `${parseFloat(stats.monthlyAttendancePercentage)}%`
                : "0%",
            p: "#11998e", s: "#38ef7d",
            path: "/team-lead/my-attendance"
        },
        {
            id: 6,
            icon: <EventBusyIcon />,
            title: "Leave Balance",
            count: stats.leaveBalance || 0,
            p: "#f093fb", s: "#f5576c",
            path: "/team-lead/leave-management/manage-leave-requests",
            dialog: "Leave Balance"
        }
    ];

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <Loader />
            </Box>
        );
    }

    return (
        <>
            <PushNotificationManager userId={userId} />
            <Container maxWidth="xl" sx={{ padding: '20px 0 !important' }}>
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    {cards.map(c => (
                        <Grid key={c.id} size={{ xs: 4, sm: 4, md: 6, lg: 4 }}>
                            <DashboardCard
                                card={c}
                                onClick={() => c.path && navigate(c.path, { state: { openDialog: c.dialog ?? null } })}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Container >
        </>
    );
}

export default TeamLeadDashboard;